import * as React from "react";
import {ChangeEvent} from "react";
import {PropertyRowComponent} from "../../../../../editor/ui/experience/widgets/toolbox/PropertiesView";
import {PropertyContainerComponent}
    from "../../../../../editor/ui/experience/widgets/toolbox/PropertyContainerComponent";
import {TextArea} from "@zmags/zmags-ui-library";

interface HtmlWidgetControlsProps {
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    htmlText: string;
}

const HtmlWidgetControls = ({onChange, htmlText}: HtmlWidgetControlsProps) => {
    return (
        <div>
            <PropertyContainerComponent
                widgetSelected={true}
                label={"Html"}
                name={"character"}
                animateExpandOnMount={true}
            >
                {/*
                        Normally this would be surrounded in a Grid element, but that breaks styling
                */}
                <PropertyRowComponent name={"html"} label={"HTML"} tip={"Enter markup here"} isColStretched={true}>
                    <TextArea
                        wrap={"off"}
                        style={{width: "100%"}}
                        resize={false}
                        contentChangeHandler={onChange}
                        initialValue={htmlText}
                    />
                </PropertyRowComponent>
            </PropertyContainerComponent>
        </div>
    );
};

export {HtmlWidgetControls as default, HtmlWidgetControls, HtmlWidgetControlsProps};



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/htmlWidget/HTMLWidgetControls.tsx